import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=bb8043f8&scoped=true&"
import script from "./TabBar.vue?vue&type=script&lang=js&"
export * from "./TabBar.vue?vue&type=script&lang=js&"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=bb8043f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8043f8",
  null
  
)

export default component.exports